export const users = [
    {
        username: 'Florence',
        password: 'Italy',
        currency: 'Euro',
        currAbr: 'EUR',
        currencySymbol: '€',
        balance: 5148.23,
        title: 'Mrs.'
    },
    {
        username: 'Bergen',
        password: 'Norway',
        currency: 'Krone',
        currAbr: 'NOK',
        currencySymbol: 'kr',
        balance: 286047.74,
        title: 'Mr.'
    },
    {
        username: 'Tokyo',
        password: 'Japan',
        currency: 'Yen',
        currAbr: 'JPY',
        currencySymbol: '¥',
        balance: 17865343.93,
        title: 'Ms.'
    },
    {
        username: 'Moscow',
        password: 'Russia',
        currency: 'Ruble',
        currAbr: 'RUB',
        currencySymbol: '₽',
        balance: 1308490.49,
        title: 'Mrs.'
    },
    {
        username: 'Sydney',
        password: 'Australia',
        currency: 'dollar',
        currAbr: 'AUD',
        currencySymbol: '$',
        balance: 12444.18,
        title: 'Mr.'
    },
    {
        username: 'Chicago',
        password: 'United States',
        currency: 'Dollar',
        currAbr: 'USD',
        currencySymbol: '$',
        balance: 5148,
        title: 'Ms.'
    },
    {
        username: 'Seoul',
        password: 'South Korea',
        currency: 'Won',
        currAbr: 'KRW',
        currencySymbol: '₩',
        balance: 703286.96,
        title: 'Mrs.'
    },
]